/**
 * @class
 */
import Base from 'netxcore@netx/core-cart/collections/cartAssets';

export default class CartAssets extends Base {
	/** @override */
	constructor(models, opts = {}) {
		super(models, opts);

		this.pager.set({routesToPage: true});
	}
}
